var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper"},[_vm._l((_vm.tabs),function(tab,index){return _c('TabHeaderItem',{key:index,attrs:{"name":tab.tabName,"icon":tab.tabIcon,"is-last":index === _vm.tabs.length - 1,"active":_vm.active === index}})}),_c('CloseIcon',{staticClass:"close-icon",on:{"click":_vm.openCancelModal}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }